import { memo } from 'react';

import Conversion from 'bloko/blocks/conversion';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import NumberFormatter from 'bloko/common/numberFormatter';
import { formatToReactComponent } from 'bloko/common/trl';

import translation from 'src/components/translation';
import { WrongPeriodType } from 'src/models/price/product.types';

export enum PeriodVariants {
    /** 30 дней */
    Default = 'default',
    /** 30 дней действия */
    Option = 'option',
    /** 30 дней доступа */
    Contacts = 'contacts',
    /** Срок доступа — 30 дней */
    ContactsDetailed = 'contactsDetailed',
    /** 30 дней на размещение */
    Publication = 'publications',
    /** Срок размещения — 30 дней */
    PublicationDetailed = 'publicationsDetailed',
    /** 30 дней на размещение и доступ к резюме */
    Bundle = 'bundle',
}

const TrlKeys = {
    [PeriodVariants.Default]: {
        one: 'price.periodInDays.one',
        some: 'price.periodInDays.some',
        many: 'price.periodInDays.many',
    },
    [PeriodVariants.Contacts]: {
        one: 'price.periodInDays.contacts.one',
        some: 'price.periodInDays.contacts.some',
        many: 'price.periodInDays.contacts.many',
    },
    [PeriodVariants.ContactsDetailed]: {
        one: 'price.periodInDays.contactsDetailed.one',
        some: 'price.periodInDays.contactsDetailed.some',
        many: 'price.periodInDays.contactsDetailed.many',
    },
    [PeriodVariants.Publication]: {
        one: 'price.periodInDays.publication.one',
        some: 'price.periodInDays.publication.some',
        many: 'price.periodInDays.publication.many',
    },
    [PeriodVariants.PublicationDetailed]: {
        one: 'price.periodInDays.publicationDetailed.one',
        some: 'price.periodInDays.publicationDetailed.some',
        many: 'price.periodInDays.publicationDetailed.many',
    },
    [PeriodVariants.Option]: {
        one: 'price.periodInDays.option.one',
        some: 'price.periodInDays.option.some',
        many: 'price.periodInDays.option.many',
    },
    [PeriodVariants.Bundle]: {
        one: 'price.periodInDays.bundle.one',
        some: 'price.periodInDays.bundle.some',
        many: 'price.periodInDays.bundle.many',
    },
};

interface PeriodInDaysProps {
    /** Период в днях */
    period: WrongPeriodType;
    /** Вариант записи */
    variant: PeriodVariants;
}

const PeriodInDays: TranslatedComponent<PeriodInDaysProps> = ({ period, variant, trls }) => {
    const parsedPeriod = parseInt(period, 10);

    if (!parsedPeriod) {
        return null;
    }

    return (
        // span для простановки атрибута source
        <span>
            <Conversion
                one={trls[TrlKeys[variant].one]}
                some={trls[TrlKeys[variant].some]}
                many={trls[TrlKeys[variant].many]}
                format={(trl) =>
                    formatToReactComponent(trl, {
                        '{0}': <span data-qa="period">{NumberFormatter.format(String(parsedPeriod))}</span>,
                    })
                }
                value={parsedPeriod}
                hasValue={false}
            />
        </span>
    );
};

export default memo(translation(PeriodInDays));
